<script setup>
import * as tools from '@/tools'

const route = useRoute()

const menuData = ref([
  {
    name: tools.t('t888'),
    path: '/',
    children: [],
  },
  {
    name: tools.t('t889'),
    path: '/about/index',
    children: [
      { name: tools.t('t890'), path: '/about/index' },
      { name: tools.t('t15'), path: '/about/sum' },
      { name: tools.t('t892'), path: '/about/tissue' },
      { name: tools.t('t893'), path: '/about/culture' },
      { name: tools.t('t894'), path: '/about/history' },
    ],
  },
  {
    name: tools.t('t895'),
    path: '/news/index',
    children: [
      { name: tools.t('t594'), path: '/news/index' },
      { name: tools.t('t595'), path: '/news/jujiao' },
      { name: tools.t('t596'), path: '/news/meiti' },
    ],
  },
  {
    name: tools.t('t925'),
    path: '/business-area',
    children: [],
  },
  {
    name: tools.t('t899'),
    path: '/business/index',
    children: [
      { name: tools.t('t900'), path: '/business/realty' },
      { name: tools.t('t901'), path: '/business/tenement' },
      { name: tools.t('t902'), path: '/business/trade' },
      { name: tools.t('t903'), path: '/business/innovate' },
    ],
  },
  {
    name: tools.t('t119'),
    path: '/corporate-information',
    children: [
      { name: tools.t('t121'), path: '/corporate-information' },
      { name: tools.t('t122'), path: '/corporate-governance' },
      { name: tools.t('t123'), path: '/announcements' },
      { name: tools.t('t124'), path: '/fin-reports' },
      { name: tools.t('t125'), path: '/esg-reports' },
      { name: tools.t('t120'), path: '/presentations' },
      { name: tools.t('t126'), path: '/newsletters' },
    ],
  },
  {
    name: tools.t('t912'),
    path: '/lean-governance',
    children: [
      { name: tools.t('t131'), path: '/lean-governance' },
      { name: tools.t('t132'), path: '/better-life' },
      { name: tools.t('t133'), path: '/green-earth' },
      { name: tools.t('t130'), path: '/people-oriented' },
      { name: tools.t('t134'), path: '/co-development' },
    ],
  },
  {
    name: tools.t('t608'),
    path: '/join/index',
    children: [
      { name: tools.t('t609'), path: '/join/index' },
      { name: tools.t('t611'), path: '/join/staff' },
      { name: tools.t('t612'), path: '/join/job' },
    ],
  },
  {
    name: tools.t('t922'),
    path: '/contact',
    children: [],
  },
])

const localeKey = computed(() => tools.i18n.global.locale)
const localeName = computed(() => tools.supportedLocales[localeKey.value])

const isActive = path => {
  const currentPath = route.path
  if (path === '/' && currentPath === '/') {
    return true
  }
  switch (path) {
    case '/about/index':
      return currentPath.startsWith('/about/') || ['/young', '/gongyi'].includes(currentPath)
    case '/news/index':
      return currentPath.startsWith('/news/')
    case '/business/index':
      return currentPath.startsWith('/business/')
    case '/corporate-information':
      return [
        '/corporate-information',
        '/corporate-governance',
        '/announcements',
        '/fin-reports',
        '/esg-reports',
        '/presentations',
        '/newsletters',
      ].includes(currentPath)
    case '/lean-governance':
      return ['/lean-governance', '/better-life', '/green-earth', '/people-oriented', '/co-development'].includes(
        currentPath,
      )
    case '/join/index':
      return currentPath.startsWith('/join/')
    case '/contact':
      return currentPath === '/contact'
    case '/business-area':
      return currentPath === '/business-area'
    default:
      return currentPath === path
  }
}

function dropMenu(obj) {
  var bname = $('.menuLi')

  $(obj).each(function (i, v) {
    var theSpan = $(v)
    var theMenu = theSpan.find('.menuListBox')
    var tarHeight = theMenu.height()

    theMenu.css({ height: 0 })
    theSpan.hover(
      function () {
        bname.find('.mainmenu').removeClass('menuLiBnameover')
        theSpan.find('.mainmenu').addClass('menuLiBnameover')
        theMenu.stop().show().animate({ height: tarHeight }, 300)
        theMenu.find('.iconfont').fadeIn(600)
      },
      function () {
        theSpan.find('.mainmenu').removeClass('menuLiBnameover')
        theMenu.stop().animate({ height: 0 }, 100, function () {
          $(this).css({ display: 'none' })
        })
      },
    )
  })
}

onMounted(() => {
  nextTick(() => {
    $(document).ready(function () {
      dropMenu('.menuLi')
    })

    $('.indexpage .menu').hover(
      function () {
        $('.indexpage .menu').addClass('hover')
        $('.indexpage .navbox').addClass('hover')
      },
      function () {},
    )
    $('.indexpage .navbox').hover(
      function () {},
      function () {
        $('.indexpage .menu').removeClass('hover')
        $('.indexpage .navbox').removeClass('hover')
      },
    )

    $('.menu-mobile .menu').click(function () {
      $('.menu-mobile .menu').toggleClass('hover')
      $('.nav-mobile').toggleClass('open')
      $('.nav-mobile-level2').slideUp()
      $('.nav-mobile-icon').removeClass('hover')
    })
    $('.menu-item a').click(function () {
      $('.menu-mobile .menu').removeClass('hover')
      $('.nav-mobile').removeClass('open')
    })

    $('.nav-mobile-icon').click(function () {
      $(this).toggleClass('hover')
      $(this).next('.nav-mobile-level2').slideToggle()
    })
  })
})
</script>

<template>
  <section class="headbox mo_undis">
    <div class="navbox tcenter cf">
      <router-link to="/" class="dis logo">
        <img src="/webpage/cn/images/logo.png" class="dis height100" />
      </router-link>
      <div class="menu box-sizing">
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
      </div>

      <div class="nav disinblock fright">
        <ul class="cf">
          <li
            v-for="item in menuData"
            :key="item.path"
            class="menuLi"
            :style="{ backgroundColor: isActive(item.path) ? '#caa678' : 'transparent' }"
          >
            <router-link :to="item.path" class="mainmenu" :class="{ menuLipitchon: isActive(item.path) }">
              {{ item.name }}
            </router-link>
            <div v-if="item.children.length" class="menuListBox">
              <router-link v-for="child in item.children" :key="child.path" :to="child.path">
                {{ child.name }}
              </router-link>
            </div>
          </li>

          <li class="menuLi">
            <a class="mainmenu" style="padding-left: 8px; padding-right: 8px">
              <i class="iconfont icon-ditu_diqiu fa-1_2x color505050 opacity0_6"></i>
              {{ localeName }}
            </a>
            <div class="menuListBox">
              <a href="javascript:void(0)" @click="tools.setLocale(localeName === 'CN' ? 'zh-TW' : 'zh-CN')">
                {{ localeName === 'CN' ? '繁' : 'CN' }}
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </section>

  <!-- 移动端菜单 -->
  <section class="menu-mobile mo_dis">
    <div class="header-mobile">
      <router-link to="/">
        <img src="/webpage/cn/images/logo.png" class="dis logo-mobile" />
      </router-link>
      <div class="menu box-sizing">
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
      </div>
    </div>
    <div class="nav-mobile">
      <ul class="menu-items cf">
        <li v-for="item in menuData" :key="item.path" class="menu-item">
          <router-link :to="item.path" class="nav-mobile-level font-bold" :class="{ active: isActive(item.path) }">
            {{ item.name }}
          </router-link>
          <template v-if="item.children.length">
            <div class="nav-mobile-icon"><i class="iconfont"></i></div>
            <div class="nav-mobile-level2">
              <router-link v-for="child in item.children" :key="child.path" :to="child.path">
                {{ child.name }}
              </router-link>
            </div>
          </template>
        </li>
      </ul>
    </div>
  </section>
</template>
